import React, { Component } from "react";
import { Button, Form } from "semantic-ui-react";
import { Slider } from "react-semantic-ui-range";
import "semantic-ui-css/semantic.min.css";

const annotationData = annotation => annotation.body[0]["value"];
const annotationText = annotation => annotation.body[1]["value"];

const ANNOTATION_MOTIVATIONS = [
  { value: "oa:commenting", text: "Commenting" },
  { value: "oa:bookmarking", text: "Bookmarking" },
  { value: "oa:classifying", text: "Classifying" },
  { value: "oa:describing", text: "Describing" },
  { value: "oa:editing", text: "Editing" },
  { value: "oa:highlighting", text: "Highlighting" },
  { value: "oa:identifying", text: "Identifying" },
  { value: "oa:linking", text: "Linking" },
  { value: "oa:moderating", text: "Moderating" },
  { value: "oa:questioning", text: "Questioning" },
  { value: "oa:replying", text: "Replying" },
  { value: "oa:tagging", text: "Tagging" }
];

export const editorDefaults = {
  language: "en",
  fontSize: 50,
  letterSpacing: 1,
  height: 100,
  placeholderText: "type here",
  motivation: "oa:commenting"
};

function propsToState(props) {
  const annotation = props.annotation || { body: [{}, {}] };
  const defaults = props.defaults || editorDefaults;
  const dataValue = annotationData(annotation);
  const textValue = annotationText(annotation);
  return {
    id: annotation.id || "",
    motivation: annotation.motivation || defaults.motivation,
    fontSize: dataValue["fontSize"] || defaults.fontSize,
    letterSpacing: dataValue["letterSpacing"] || defaults.letterSpacing,
    value: textValue
  };
}

export default class AnnotationEditor extends Component {
  constructor(props) {
    super(props);
    this.state = propsToState(props);
  }

  handleValueChange = event => {
    this.props.onValueChanged(event.target.value);
  };

  handleFontSizeChange = v => {
    this.props.onFontSizeChanged(v);
  };

  handleLetterSpacingChange = v => {
    this.props.onLetterSpacingChanged(v);
  };

  handleMotivationChange = (e, { value }) => {
    this.props.onMotivationChanged(value);
  };

  static getDerivedStateFromProps(props, _) {
    if (props.annotation) {
      return propsToState(props);
    }
  }

  render() {
    const { annotation, onDelete, onSave, placeholderText } = this.props;
    return (
      <Form>
        <Form.Field>
          <label>Motivation</label>
          <Form.Select
            options={ANNOTATION_MOTIVATIONS}
            value={this.state.motivation}
            onChange={this.handleMotivationChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Value</label>
          <textarea
            onChange={this.handleValueChange}
            placeholder={placeholderText}
            value={this.state.value}
          />
        </Form.Field>
        <Form.Field>
          <label>Font-size: {this.state.fontSize}</label>
          <Slider
            value={this.state.fontSize}
            color="red"
            discrete
            settings={{
              min: 20,
              max: 400,
              step: 1,
              onChange: this.handleFontSizeChange
            }}
          />
        </Form.Field>
        <Form.Field>
          <label>Letter Spacing: {this.state.letterSpacing}</label>
          <Slider
            value={this.state.letterSpacing}
            color="red"
            discrete
            settings={{
              min: 1,
              max: 400,
              step: 1,
              onChange: this.handleLetterSpacingChange
            }}
          />
        </Form.Field>
        <Form.Field>
          <Button color="teal" onClick={() => onSave(annotation)}>
            Save
          </Button>
          <Button color="red" onClick={() => onDelete(annotation)}>
            Delete
          </Button>
        </Form.Field>
      </Form>
    );
  }
}

export function annotationToObj({ annotation, parent }) {
  const fontSize =
    annotation.body[0]["value"]["fontSize"] || editorDefaults.fontSize;
  const letterSpacing =
    annotation.body[0]["value"]["letterSpacing"] ||
    editorDefaults.letterSpacing;
  return {
    ID: [`${parent.ID[0]}_${annotation.id}`],
    TYPE: ["annotation"],
    PARENT: [`${parent.ID[0]}`],
    DIMENSION: [
      `${annotation.x} ${annotation.y} ${annotation.width} ${annotation.height}`
    ],
    MOTIVATION: [`${annotation.motivation}`],
    TEXT: [`${annotation.body[1]["value"]}`],
    FONT_SIZE: [`${fontSize}`],
    LETTER_SPACING: [`${letterSpacing}`]
  };
}
